import React, { FC, useState } from "react";
import { faListCheck } from "@fortawesome/free-solid-svg-icons";
import { useTodoContext } from "../../todos/useTodoContext";
import { TodoList } from "./TodoList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const TodoBadgeButton: FC = () => {
  const { pendingCount } = useTodoContext()
  const [isOpen, setIsOpen] = useState(false)

  return <div className={"relative h-full w-20"}>
    <button className={"flex items-center hover:bg-[#0004] cursor-pointer px-6 -mx-6 h-full"} onClick={() => setIsOpen(o => !o)}>
      <FontAwesomeIcon icon={faListCheck} />
      {pendingCount > 0 ? <div className='ml-1 px-1 h-5 min-w-5 text-xs flex items-center justify-center rounded-full border border-red-500 bg-red-700'>
        <div className='mt-[1px]'>{pendingCount}</div>
      </div> : <></>}
    </button>
    {isOpen && <>
      <div className={"fixed inset-0 z-10"} onClick={() => setIsOpen(false)} />
      <div className={"absolute top-12 right-0 w-96 max-h-[70vh] overflow-y-auto text-black bg-white border border-slate-200 rounded-sm shadow-lg z-40 p-4"}>
        <TodoList hideDoneItems={true} />
      </div>
    </>}
  </div>
}
